import PropTypes from 'prop-types';
import React from 'react';

const ShippingTime = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    className={className}
  >
    <ellipse
      cx="4.9602"
      cy="4.5039"
      rx="2.9602"
      ry="3.0048"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="3.724 3.24 4.96 4.504 5.857 3.593"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
      fillRule="evenodd"
    />
    <line
      x1="2.5681"
      y1="11.8359"
      x2="17.7917"
      y2="11.8359"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="9.258 5.837 12.582 5.837 12.582 14.586 9.997 14.586"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="5.297 14.586 2.568 14.586 2.568 8.732"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="12.582 14.586 12.582 7.67 15.537 7.67 18 12.044 18 14.586"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="15.2912"
      cy="15.0009"
      r="1.5"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="7.6633"
      cy="14.9645"
      r="1.5"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShippingTimeNew = ({ className }) => (
  <svg width="28" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect x="4" width="24" height="24" rx="12" fill="#C5E8D5" />
    <path
      d="M17.666 7.835h1.837c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l3.23 3.23c.172.173.259.26.32.36.055.09.096.188.12.29.028.115.028.237.028.482v2.254c0 .232 0 .348-.02.445a1 1 0 0 1-.785.785c-.097.02-.213.02-.445.02v0m-5.417 0h1.25"
      stroke="#006B4D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.333 16.169h3.333V8.535c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218h-5.2c-.56 0-.84 0-1.054.11a1 1 0 0 0-.437.436c-.109.214-.109.494-.109 1.054v7.567c0 .92.746 1.667 1.667 1.667v0"
      stroke="#006B4D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.834 18.669a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm9.166 0a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167ZM10.5 9.25H3m4.167 3.583H1.334"
      stroke="#006B4D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ShippingTime.propTypes = {
  className: PropTypes.string,
};
ShippingTimeNew.propTypes = {
  className: PropTypes.string,
};

export default ShippingTime;
